export default __webpack_public_path__ + "assets/images/181a6691502b12ee2730a8d547dee6c1.jpg";